import { AdsChunkSize } from '@/components/AdsWithInfiniteScroll/AdsWithInfiniteScroll.types';

export const SCROLL_GAP = 0;
export const SCROLL_STEP = 600;
export const SCROLL_THRESHOLD = 0;
export const BULK_PROMOTION_MAX_SELECTION = 12;

// One bundle of expired ads can be restored at a time (matches the list page size).
export const RESTORE_MAX_SELECTION = AdsChunkSize.Middle;
